export default __webpack_public_path__ + "static/media/The-Mandalorian.91384f80.webp";